/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { Environment } from '../../models/environment';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { EnvironmentService } from './environment.service';

@Injectable()
export class EvidenceService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
    }

    /**
     * Obtener un informe de la evidencia según el identificador de la operación y el tipo de evidencia
     *
     * @param authorization The authorization token
     * @param idCircuit Identificador interno del circuito
     * @param externalIdCircuit Identificador externo del circuito
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evidenceGetCircuitEvidence(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evidenceGetCircuitEvidence(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evidenceGetCircuitEvidence(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evidenceGetCircuitEvidence(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling evidenceGetCircuitEvidence.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (externalIdCircuit !== undefined && externalIdCircuit !== null) {
            queryParameters = queryParameters.set('externalIdCircuit', <any>externalIdCircuit);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Evidence/CircuitEvidence`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Descarga el fichero evi de una evidencia
     *
     * @param idEvidence Identificador de la evidencia
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evidenceGetDownloadEvidence(idEvidence: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evidenceGetDownloadEvidence(idEvidence: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evidenceGetDownloadEvidence(idEvidence: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evidenceGetDownloadEvidence(idEvidence: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idEvidence === null || idEvidence === undefined) {
            throw new Error('Required parameter idEvidence was null or undefined when calling evidenceGetDownloadEvidence.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling evidenceGetDownloadEvidence.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idEvidence !== undefined && idEvidence !== null) {
            queryParameters = queryParameters.set('idEvidence', <any>idEvidence);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Evidence/DownloadEvidence`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Descarga el fichero evi de una evidencia
     *
     * @param idEvidence Identificador de la evidencia
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evidenceGetEvidencePDF(idEvidence: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evidenceGetEvidencePDF(idEvidence: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evidenceGetEvidencePDF(idEvidence: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evidenceGetEvidencePDF(idEvidence: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idEvidence === null || idEvidence === undefined) {
            throw new Error('Required parameter idEvidence was null or undefined when calling evidenceGetEvidencePDF.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling evidenceGetEvidencePDF.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idEvidence !== undefined && idEvidence !== null) {
            queryParameters = queryParameters.set('idEvidence', <any>idEvidence);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Evidence/EvidencePDF`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

}
